export const theme = {
  colors: {
    main: {
      orangeMain: '#FF7601',
      white: '#FFFFFF',
      orangeLight: '#FFF1E5',
      grayLight: '#EBEBEB',
    },
    text: {
      text: '#52555F',
      gray: '#A6ABB9',
      greenMain: '#01AB3A',
      expenses: '#FF1717',
    },
    diagram: {
      yellow: '#F2FF5C',
      greenLight: '#9DF37F',
      emeraldLight: '#2CCDA6',
      mustard: '#FFA901',
      pink: '#FF068D',
      blue: '#652FFF',
      violet: '#8B44FF',
      red: '#F47979',
      lilac: '#D661FF',
      expenses: '#FF1717',
      greenMain: '#01AB3A',
    },
    gradient: {
      green: '#00AA3A, #ECECEC',
      orange: '#FF7500, #ECECEC',
      chartOrange: '#FF751D, #FFF1E5',
      chartGreen: '#01AB3A, #F4FFF4',
      chartRed: '#FF1717, #FFFAFA',
    },
  },
  input: {
    active: '1px solid #FF7601',
    arror: '1px solid #FF1717',
    succes: '1px solid #01AB3A',
  },
  width: {
    mobile: '360px',
  },
  switch: {
    lightMode: '#FF7601',
    darkMode: '#52555F',
  },
  ui: {
    scheme: 'light',
    /** Как у карточек Home: Tailwind shadow-sm в светлой теме */
    cardShadow: '0 1px 2px 0 rgba(15, 23, 42, 0.05)',
  },
  loader: {
    backdrop: 'rgba(15, 23, 42, 0.28)',
    wrapShadow: '2px 8px 80px rgba(170, 178, 197, 0.25)',
    wrapBorder: '1px solid transparent',
  },
  modal: {
    zIndexBackdrop: 500,
    backdrop: 'rgba(15, 23, 42, 0.42)',
    backdropBlur: 'blur(4px)',
    panelShadow: '0 24px 60px rgba(15, 23, 42, 0.2)',
    radiusSheet: '24px',
    radiusDialog: '30px',
    elevatedSoft: '2px 4px 20px rgba(170, 178, 197, 0.25)',
    elevatedPopover: '2px 4px 20px rgba(170, 178, 197, 0.25)',
    subscriptionsButton: '2px 4px 20px 0px rgba(170, 178, 197, 0.25)',
    subscriptionsPlan: '2px 4px 20px 0px rgba(170, 178, 197, 0.25)',
    ctaGlow: '4px 4px 16px rgba(255, 107, 8, 0.25)',
    chipNeutralShadow: '4px 4px 16px 0px rgba(170, 178, 197, 0.25)',
    selectMenuFloater: '4px 4px 16px rgba(170, 178, 197, 0.25)',
  },
};

export const darkTheme = {
  colors: {
    main: {
      orangeMain: '#FF7601',
      white: '#0F172A',
      orangeLight: '#1E293B',
      grayLight: '#334155',
    },
    text: {
      text: '#E2E8F0',
      gray: '#94A3B8',
      greenMain: '#22C55E',
      expenses: '#FB7185',
    },
    diagram: {
      yellow: '#F2FF5C',
      greenLight: '#86EFAC',
      emeraldLight: '#34D399',
      mustard: '#F59E0B',
      pink: '#F472B6',
      blue: '#818CF8',
      violet: '#A78BFA',
      red: '#FB7185',
      lilac: '#C084FC',
      expenses: '#FB7185',
      greenMain: '#22C55E',
    },
    gradient: {
      green: '#22C55E, #1E293B',
      orange: '#FF7601, #1E293B',
      chartOrange: '#FF7601, #1E293B',
      chartGreen: '#22C55E, #1E293B',
      chartRed: '#FB7185, #1E293B',
    },
  },
  input: {
    active: '1px solid #FF7601',
    arror: '1px solid #FB7185',
    succes: '1px solid #22C55E',
  },
  width: {
    mobile: '360px',
  },
  switch: {
    lightMode: '#FF7601',
    darkMode: '#334155',
  },
  ui: {
    scheme: 'dark',
    /** Как .theme-dark .shadow-sm на главной (index.css) */
    cardShadow: '0 10px 30px rgba(2, 6, 23, 0.65)',
  },
  loader: {
    backdrop: 'rgba(0, 0, 0, 0.62)',
    wrapShadow: '0 20px 56px rgba(0, 0, 0, 0.55)',
    wrapBorder: '1px solid #334155',
  },
  modal: {
    zIndexBackdrop: 500,
    backdrop: 'rgba(0, 0, 0, 0.75)',
    backdropBlur: 'blur(4px)',
    panelShadow: '0 24px 56px rgba(0, 0, 0, 0.55)',
    radiusSheet: '24px',
    radiusDialog: '30px',
    elevatedSoft: '0 8px 28px rgba(0, 0, 0, 0.45)',
    elevatedPopover: '0 16px 40px rgba(0, 0, 0, 0.5)',
    subscriptionsButton: '0 8px 24px rgba(0, 0, 0, 0.4)',
    subscriptionsPlan: '0 12px 36px rgba(0, 0, 0, 0.45)',
    ctaGlow: '4px 4px 16px rgba(255, 107, 8, 0.25)',
    chipNeutralShadow: '0 4px 16px rgba(0, 0, 0, 0.35)',
    selectMenuFloater: '0 12px 32px rgba(0, 0, 0, 0.55)',
  },
};
